import styled from 'styled-components';
import THEME from '../theme';
const Well = styled.div `
  background-color: #e6e6e6;
  border-radius: 2px;
  padding: ${THEME.GRID_SPACING}px;
`;
export default Well;
//# sourceMappingURL=Well.js.map